import {IpproMapFeatureStyle} from '@/app/shared/components/ippro-map/vl-ippro-map';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import CircleStyle from 'ol/style/Circle';

export const defaultStyle: IpproMapFeatureStyle = {
    default: new Style({
        fill: new Fill({
            color: "rgba(0, 85, 204, 0.6)"
        }),
        stroke: new Stroke({
            color: "rgba(0, 85, 204, 0.8)",
            width: 2
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: "rgba(0, 85, 204, 0.6)"
            }),
            stroke: new Stroke({
                color: "rgba(0, 85, 204, 0.8)",
                width: 1
            })
        })
    }),
    active: new Style({
        fill: new Fill({
            color: "rgba(0, 85, 204, 0.9)"
        }),
        stroke: new Stroke({
            color: "rgba(0, 85, 204, 1)",
            width: 2
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: "rgba(0, 85, 204, 0.9)"
            }),
            stroke: new Stroke({
                color: "rgba(0, 85, 204, 1)",
                width: 1
            })
        })
    })
};
